{
  "serie": {
    "display": "Mostrar el diagrama",
    "hide": "Ocultar el diagrama",
    "remove": "Retirar el diagrama",
    "displaySettings": "Mostrar la configuración del diagrama",
    "selectColor": "Haga clic para seleccionar un color",
    "color": "Color",
    "type": "Tipo",
    "types": {
      "line": "Línea",
      "bar": "Barra"
    }
  }
}
